import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { UserDataContext } from "../Contexts/UserDataContext";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  header: {
    padding: theme.spacing(0.5),
    fontSize: "13px",
    fontWeight: "bold",
  },
}));

function ChargeSummaryTable(props) {
  const { invoiceId, ...rest } = props;
  const { userData } = useContext(UserDataContext);
  const [rows, setRows] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios({
          method: "GET",
          url: `/invoices/getInvoiceActivities/${invoiceId}`,
          headers: {
            Authorization: `bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        });
        console.log(res.data);
        setRows(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  return (
    <Table {...rest}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.header}>Activity</TableCell>
          <TableCell className={classes.header}>Charge</TableCell>
          <TableCell className={classes.header}>F.A.F</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((dpcType) => (
          <TableRow key={dpcType.id}>
            <TableCell>{dpcType.description}</TableCell>
            <TableCell>{`$${(Math.round(dpcType.netAmount * 100) / 100).toFixed(
              2
            )}`}</TableCell>
            <TableCell>{`$${(Math.round(dpcType.faf * 100) / 100).toFixed(
              2
            )}`}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default ChargeSummaryTable;

ChargeSummaryTable.propTypes = {
  invoiceId: PropTypes.string.isRequired,
};
